module.exports = __webpack_public_path__ + "static/media/VapesYArreglaAColor.f138568b.png";